/* eslint-disable @typescript-eslint/no-this-alias */

import { SPD } from '../spd';
import {
  DEBUG_MODE,
  getBuildVersion,
  getUrlActualVersionAvailable,
  getUrlSuspend,
  ulrDefaultDbTexts,
} from '../spdConfig';

import { ActiveStep } from './activeStep';
import { FooterTools } from './footerTools';
import { Loader } from './loader';
import { TextSelector } from './textSelector';

declare let spd: SPD;
declare let defaultDbTextSelector: TextSelector;

/// Zarządzanie wersjami oprogramowania
export class VersionChecker {
  protected refreshInterval: ReturnType<typeof setInterval> | null = null;

  public async isServiceSPDAvailable() {
    const that = this;
    try {
      const json = await Loader.getSyncJSONWithVersion(
        getUrlSuspend() + '?t=' + new Date().toISOString(),
        null,
        false,
      );
      DEBUG_MODE && console.log('isServiceSPDAvailable', json);
      if (json.suspend) {
        await defaultDbTextSelector.loadDbTexts(ulrDefaultDbTexts);
        DEBUG_MODE && console.log('Blockade service');
        const data = {
          title: defaultDbTextSelector.getText('suspend_title'),
          description: defaultDbTextSelector.getText('suspend_description'),
          version: getBuildVersion(),
        };
        Loader.loadContentWithVersion(
          '#main',
          'template/suspend_page-template.mst',
          data,
          function () {
            FooterTools.addTools({
              logout: false,
              powered: true,
              lange: true,
              speaker: false,
              mode: true,
              help: false,
              version: true,
              fullscreen: true,
              refresh: true,
            });
            ActiveStep.setActiveStepAfter(() => that.isServiceSPDAvailable());
          },
        );
        return false;
      }
    } catch (e) {
      DEBUG_MODE && console.log('isServiceSPDAvailable', e);
    }
    return true;
  }

  public activateStatusVersionCheck() {
    const that = this;
    if (!this.refreshInterval) {
      this.refreshInterval = setInterval(async () => {
        if (await that.isNewVersionAvailable()) {
          /// jest dostępna nowa wersja
          spd.restartSPD();
        }
        await that.isServiceSPDAvailable();
      }, 300000); // Co 5 minut sprawdzam czy nie ma nowej wersji lub czy nie zostały podjęte prace techniczne
    }
  }
  public deactivateStatusVersionCheck() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }
  protected async isNewVersionAvailable() {
    try {
      const json = await Loader.getSyncJSONWithVersion(
        getUrlActualVersionAvailable() + '?t=' + new Date().toISOString(),
        null,
        false,
      );
      const myVersion = getBuildVersion();
      DEBUG_MODE &&
        console.log('isNewVersionAvailable', json, 'myVersion', myVersion);
      return json.version && myVersion < json.version;
    } catch (e) {
      DEBUG_MODE && console.log('isNewVersionAvailable', e);
    }
    return false;
  }
}
